import { createI18n } from 'vue-i18n'
import ar from "@/locales/ar.json"

export const i18n = createI18n(
  {
    locale: 'ar',
    fallbackLocale: 'ar',
    messages: {
     ar
    }
  },
  {
    // something vue-i18n options here ...
  }
)
